// removed by extract-text-webpack-plugin
module.exports = {"botIcon":"ChatWindow_botIcon_1Y6j5","categoryCard":"ChatWindow_categoryCard_2K86R","analytics_icon":"ChatWindow_analytics_icon_2IxK_","faq_icon":"ChatWindow_faq_icon_m1Kv4"};


//////////////////
// WEBPACK FOOTER
// ./src/docs/examples/ChatWindow/ChatWindow.css
// module id = 13
// module chunks = 0